import React from 'react'
import './Main.css'

import Home from './Home/Home'
import About from './About/About'
import Skills from './Skills/Skills'
import Qualification from './Qualification/Qualification'
import Services from './Services/Services'
import Portfolio from './Portfolio/Portfolio'
import ProjectInMind from './ProjectInMind/ProjectInMind'
import { ContactMe } from './ContactMe/ContactMe'
import Testimonial from './Testimonial/Testimonial'

const Main = props => {

    return (
        <main class="main">

            <Home />

            <About />

            <Skills />

            <Qualification />

            <Services />

            <Portfolio />

            <ProjectInMind />
  
            <Testimonial />

            <ContactMe />

        </main>
    )
}

export default Main